export default __webpack_public_path__ + "static/media/share.e5de5e81.png";